import axios, { AxiosError } from "axios";
const DivisionResource = {
    get(divisionId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/divisions/${divisionId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    search(searchParams, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/divisions`, {
            params: searchParams
        })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default DivisionResource;
